import { useCallback } from 'react';
import { useAppDispatch } from './core';
import { pushModal, popModal, clearModals } from '../slices/modalSlice';
import { ModalType } from '../../components/modals';

export const useModal = () => {
  const dispatch = useAppDispatch();

  const open = useCallback(
    (modalType: ModalType, modalProps?: Record<string, any>) => {
      dispatch(pushModal({ modalType, modalProps }));
    },
    [dispatch],
  );

  const close = useCallback(() => {
    dispatch(popModal());
  }, [dispatch]);

  const clearAll = useCallback(() => {
    dispatch(clearModals());
  }, [dispatch]);

  return {
    open,
    close,
    clearAll,
  };
};
